import { render, staticRenderFns } from "./ivr-call-initiator.vue?vue&type=template&id=53c92ca6&scoped=true"
import script from "./ivr-call-initiator.vue?vue&type=script&lang=js"
export * from "./ivr-call-initiator.vue?vue&type=script&lang=js"
import style0 from "./ivr-call-initiator.vue?vue&type=style&index=0&id=53c92ca6&prod&lang=scss&scoped=true"
import style1 from "./ivr-call-initiator.vue?vue&type=style&index=1&id=53c92ca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c92ca6",
  null
  
)

export default component.exports